import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  closeOverlay as closeOverlayAction,
  openOverlay as openOverlayAction
} from 'app/actions/FullScreenOverlayActions';
import { CONTENT_PROVIDER_IDS } from 'app/constants/BibConstants';
import { selectOpenOverlays } from 'app/selectors/ui/FullScreenOverlaySelector';
import MoreFromProvider from './MoreFromProvider';

const MoreFromProviderContainer = ({
  className,
  metadataId,
  onOverlayOpen,
  providerId,
  renderOverlayContent,
  showHeading
}) => {
  const dispatch = useDispatch();
  const openOverlays = useSelector(selectOpenOverlays);

  const overlayKey = `more-from-${providerId}-fullscreen-overlay`;
  const isOverlayOpen = openOverlays.getIn([overlayKey, 'open']) ?? false;

  useEffect(() => {
    if (!(isOverlayOpen && onOverlayOpen)) {
      return;
    }

    onOverlayOpen();
  }, [isOverlayOpen, onOverlayOpen]);

  const closeOverlay = () => {
    dispatch(closeOverlayAction(overlayKey));
  };

  const openOverlay = () => {
    dispatch(openOverlayAction(overlayKey));
  };

  return (
    <MoreFromProvider
      className={className}
      closeOverlay={closeOverlay}
      metadataId={metadataId}
      openOverlay={openOverlay}
      overlayKey={overlayKey}
      providerId={providerId}
      renderOverlayContent={renderOverlayContent}
      showHeading={showHeading}
    />
  );
};

MoreFromProvider.defautlProps = {
  className: '',
  onOverlayOpen: null,
  showHeading: true
};

MoreFromProviderContainer.propTypes = {
  className: PropTypes.string,
  metadataId: PropTypes.string.isRequired,
  onOverlayOpen: PropTypes.func,
  providerId: PropTypes.oneOf(Object.values(CONTENT_PROVIDER_IDS)).isRequired,
  renderOverlayContent: PropTypes.func.isRequired,
  showHeading: PropTypes.bool
};

export default MoreFromProviderContainer;
